import * as React from 'react';
import { styled } from '@mui/material/styles';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import CircleIcon from '@mui/icons-material/FiberManualRecord';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
    value: string;
    onChange: FlowAnyFunction;
    options: Array<{
        value: string;
        label: string;
        colors: string[];
    }>;
};

const StyMenuItem = styled('div', {
    name: 'StyMenuItem',
})({
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    textAlign: 'center',
    width: '100%',
});

function ColorSelector(props: Props) {
    const { t } = useTranslation();
    const handleChange = (e: SelectChangeEvent) => {
        props.onChange(e.target.value);
    };

    return (
        <FormControl
            variant="standard"
            fullWidth
            className="e2e-color-selector"
        >
            <InputLabel htmlFor="color-palette-selector">
                {t('colorPalette.title')}
            </InputLabel>
            <Select
                variant="standard"
                value={props.value}
                onChange={handleChange}
                input={<Input id="color-palette-selector" />}
                SelectDisplayProps={{ style: { display: 'flex' } }}
            >
                {props.options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        <StyMenuItem>
                            <ListItemIcon>
                                <Box sx={{ display: 'flex' }}>
                                    {option.colors.slice(0, 6).map((color) => (
                                        <CircleIcon
                                            key={color}
                                            sx={{ color, height: '100%' }}
                                        />
                                    ))}
                                </Box>
                            </ListItemIcon>
                            <ListItemText primary={option.label} />
                        </StyMenuItem>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default ColorSelector;
